export default class Vector {
    constructor(x, y) {
        /** @type {number} */
        this.x = x;
        
        /** @type {number} */
        this.y = y;
    }
    
    add(vector) {
        return new Vector(
            this.x + vector.x,
            this.y + vector.y
        );
    }
    
    subtract(vector) {
        return new Vector(
            this.x - vector.x,
            this.y - vector.y
        );
    }

    scale(factor) {
        return new Vector( this.x * factor, this.y * factor );
    }
}